import { render, staticRenderFns } from "./StartupListTable.vue?vue&type=template&id=138da2ae&scoped=true&"
import script from "./StartupListTable.vue?vue&type=script&lang=js&"
export * from "./StartupListTable.vue?vue&type=script&lang=js&"
import style0 from "./StartupListTable.vue?vue&type=style&index=0&id=138da2ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138da2ae",
  null
  
)

export default component.exports